"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchDrmToken = exports.fetchPrograms = void 0;
var axios_1 = __importDefault(require("axios"));
var models_1 = require("../models");
var graphql_1 = require("graphql");
var drm_query_1 = require("../queries/drm-query");
function queryRequest(_a) {
    var apiUrl = _a.apiUrl, _b = _a.usePost, usePost = _b === void 0 ? false : _b, query = _a.query, _c = _a.variables, variables = _c === void 0 ? {} : _c;
    var config = {
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        timeout: 10000,
    };
    var sdl = (0, graphql_1.print)(query);
    var params = {
        operationName: null,
        query: (0, graphql_1.stripIgnoredCharacters)(sdl),
        variables: variables,
    };
    if (usePost) {
        return axios_1.default.post(apiUrl, params, config);
    }
    return axios_1.default.get(apiUrl, __assign({ params: __assign(__assign({}, params), { variables: JSON.stringify(variables) }) }, config));
}
var fetchPrograms = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var responseData, _c, data, errors, error_1;
    var _d, _e, _f, _g, _h, _j;
    var videoApiEndpoint = _b.videoApiEndpoint, query = _b.query, variables = _b.variables;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _k.trys.push([0, 2, , 3]);
                return [4, queryRequest({
                        apiUrl: videoApiEndpoint,
                        query: query,
                        variables: variables,
                    })];
            case 1:
                responseData = (_k.sent()).data;
                _c = responseData || {}, data = _c.data, errors = _c.errors;
                if (errors) {
                    throw new Error(((_d = errors[0]) === null || _d === void 0 ? void 0 : _d.message) || 'GraphQL request failed');
                }
                if (!((_f = (_e = data === null || data === void 0 ? void 0 : data.programs) === null || _e === void 0 ? void 0 : _e.items) === null || _f === void 0 ? void 0 : _f.length)) {
                    return [2, []];
                }
                return [2, new models_1.Playlist(data).items];
            case 2:
                error_1 = _k.sent();
                throw new Error(((_j = (_h = (_g = error_1.response) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.errors[0]) === null || _j === void 0 ? void 0 : _j.message) || error_1.message);
            case 3: return [2];
        }
    });
}); };
exports.fetchPrograms = fetchPrograms;
var fetchDrmToken = function (_a) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([_a], args_1, true), void 0, function (_b, provider) {
        var data;
        var videoApiEndpoint = _b.videoApiEndpoint;
        if (provider === void 0) { provider = 'MPX'; }
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4, queryRequest({
                        apiUrl: videoApiEndpoint,
                        query: drm_query_1.drmQuery,
                        variables: {
                            provider: provider,
                        },
                        usePost: true,
                    })];
                case 1:
                    data = (_c.sent()).data;
                    return [2, data.data.drmToken.token || ''];
            }
        });
    });
};
exports.fetchDrmToken = fetchDrmToken;
